const steps = [
  {
    id: 1,
    number: "01",
    title: "Opportunity announced",
    detail:
      "A partner-supported programme opens with clear eligibility, learning area and timeline.",
  },
  {
    id: 2,
    number: "02",
    title: "Application reviewed",
    detail:
      "Candidates share their goals, context and readiness for the learning commitment.",
  },
  {
    id: 3,
    number: "03",
    title: "Selection completed",
    detail:
      "The programme team applies the published criteria for the specific scholarship.",
  },
  {
    id: 4,
    number: "04",
    title: "Learning begins",
    detail:
      "Selected learners enter a structured programme with practical work and support.",
  },
];

const ScholarshipProcessSection = () => {
  return (
    <section className="w-full bg-white py-16 lg:py-[105px] px-6 lg:px-8">
      <div className="container mx-auto">
        <div className="scholarship-grid-heading grid items-end gap-5 lg:gap-20 mb-10 lg:mb-12">
          <div>
            <p className="flex items-center gap-3 text-primary font-poppins text-sm font-extrabold tracking-widest uppercase mb-5">
              <span className="w-8 h-1 rounded-full bg-secondary inline-block"></span>
              How Scholarships Work
            </p>
            <h2
              className="text-primary font-poppins font-bold tracking-[-0.045em] m-0"
              style={{ fontSize: "clamp(32px, 4vw, 55px)", lineHeight: 1.12 }}
            >
              Funding connected to preparation and progress.
            </h2>
          </div>
          <p className="text-gray font-poppins text-[17px] leading-[1.8] m-0">
            Scholarship structures vary by partner, programme and cohort, but
            the learner journey follows a clear path.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-[15px]">
          {steps.map((step) => (
            <article
              key={step.id}
              className="flex flex-col min-h-[280px] lg:min-h-[320px] p-[29px] bg-white border border-hire-line rounded-[22px]"
              style={{ boxShadow: "0 17px 45px rgba(31,34,48,0.055)" }}
            >
              <span className="text-[#9a6500] font-poppins tracking-[0.05em] text-sm font-extrabold">
                {step.number}
              </span>
              <h3 className="text-primary font-poppins font-bold tracking-[-0.025em] text-2xl leading-[1.28] mt-auto mb-3">
                {step.title}
              </h3>
              <p className="text-gray font-poppins text-base leading-[1.72] m-0">
                {step.detail}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ScholarshipProcessSection;
